var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{directives:[{name:"show",rawName:"v-show",value:(!_vm.isProduction),expression:"!isProduction"}],staticClass:"fixed-bottom"},[_c('span',{staticClass:" badge",class:{
      'badge-info': _vm.isProduction,
      'badge-primary': !_vm.isProduction
    }},[_vm._v("\n    Release: "+_vm._s(_vm.release)+"\n  ")])])}
var staticRenderFns = []

export { render, staticRenderFns }